<form [formGroup]="ticketForm" (ngSubmit)="onSubmit()" novalidate>
  <div class="flex items-center justify-center dialog-header">
    {{type}} Ticket
    <div class="absolute right-2">
      <button (click)="handleCloseDialog()" class="outline-none p-5">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </div>

  <div class="dialog-content" style="margin-top: -15px;">

    <div class="field">
      <label class="requiredValue">Title</label>
      <input pInputText formControlName="title" placeholder="Ticket Title" />
      <small *ngIf="ticketForm.get('title')?.invalid && isSubmitted" class="p-error">Title is required</small>
    </div>

    <div class="field">
      <label class="requiredValue">Description</label>
      <textarea pTextarea formControlName="ticket_desc" rows="4" placeholder="Enter description"></textarea>
      <small *ngIf="ticketForm.get('ticket_desc')?.invalid && isSubmitted" class="p-error">Description is
        required</small>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 md:gap-2">
      <div class="field">
        <label class="requiredValue">Status</label>
        <p-select appendTo="body" [options]="ticketStatusOptions" formControlName="ticket_status"
          placeholder="Select Status"></p-select>
        <small *ngIf="ticketForm.get('ticket_status')?.invalid && isSubmitted" class="p-error">Status is
          required</small>
      </div>

      <div class="field">
        <label>Assign To</label>
        <p-select appendTo="body" [options]="users" formControlName="assign_to" placeholder="Select Assignee"
          [optionLabel]="'label'" [optionValue]="'value'"></p-select>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 md:gap-2">
      <div class="field">
        <label class="requiredValue">Priority</label>
        <p-select appendTo="body" [options]="priorityOptions" formControlName="priority"
          placeholder="Select Priority"></p-select>
        <small *ngIf="ticketForm.get('priority')?.invalid && isSubmitted" class="p-error">Priority is required</small>
      </div>

      <div class="field">
        <label class="requiredValue">Source</label>
        <p-select appendTo="body" [options]="sourceOptions" formControlName="source"
          placeholder="Select Source"></p-select>
        <small *ngIf="ticketForm.get('source')?.invalid && isSubmitted" class="p-error">Source is required</small>
      </div>
    </div>

    <div class="field">
      <label>Attachments</label>

      <!-- Hidden native file input -->
      <input type="file" multiple (change)="onFileSelected($event)" #fileInput hidden />

      <!-- PrimeNG Button triggers file input -->
      <button pButton type="button" icon="pi pi-upload" label="{{ imgTitle }}" (click)="fileInput.click()"
        [loading]="loading"></button>

      <!-- Preview thumbnails -->
      <div class="flex flex-wrap gap-4 mt-3">
        <div *ngFor="let file of totalFiles; let i = index" class="relative w-28">

          <!-- Image Preview -->
          <img *ngIf="isImage(file.file.name)" [src]="file.preview"
            class="w-full h-24 object-cover rounded-md border" />

          <!-- Video Preview -->
          <video *ngIf="isVideo(file.file.name)" [src]="file.preview" class="w-full h-24 rounded-md border" controls
            muted></video>

          <!-- PDF Icon -->
          <div *ngIf="isPDF(file.file.name)"
            class="flex items-center justify-center w-full h-24 bg-gray-100 rounded-md border">
            <i class="pi pi-file-pdf text-red-600 text-3xl"></i>
          </div>

          <!-- File name and delete button overlay -->
          <div
            class="absolute bottom-0 left-0 right-0 bg-black bg-opacity-60 text-white text-xs flex justify-between items-center px-2">
            <span class="truncate max-w-[80px]">{{ file.file.name }}</span>
            <button pButton icon="pi pi-trash" class="p-button-text p-button-danger p-0" style="min-width: 25px;max-width: 25px;" (click)="removeFile(i)"></button>
          </div>
        </div>
      </div>
    </div>



    <div class="flex justify-end gap-2 mt-8">
      <p-button label="Cancel" severity="danger" variant="outlined" (click)="handleCloseDialog()"></p-button>
      <p-button label="Save" icon="pi pi-save" [loading]="btnLoading" [disabled]="btnLoading"
        (click)="onSubmit()"></p-button>
    </div>
  </div>
</form>